import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';
import BottomNav from './BottomNav.jsx';
import PWAUpdateNotice from './PWAUpdateNotice.jsx';
import AvisoSemDado from './AvisoSemDado.jsx';
import { useData } from '../contexts/DataContext.jsx';
import { CADASTRO_SEED_TRAVADO, CRM_VIGIA } from '../config/featureFlags.js';
import { CADASTRO_SEM_COFRE } from '../utils/textosSemDado.js';
// 30/10/2026 (CRM_VIGIA): o aviso de mensagem nova do CRM em todas as telas, para quem tem o CRM no menu
import VigiaCrm from './crm/VigiaCrm.jsx';

// Rotas full-bleed: a página gerencia o próprio scroll/layout, sem padding
// nem overflow:auto no <main> (evita duplo-scroll e borda bege em volta).
const FULL_BLEED_ROUTES = ['/gestao/agenda'];

// CADASTRO_SEED_TRAVADO (28/10/2026): o aparelho não semeia mais o cadastro.
// Sem cópia e sem resposta do servidor as listas ficam vazias; esta linha diz
// por quê (sem dado = vazio + aviso) e deixa tentar de novo.
function AvisoCadastroSemCofre() {
  const { _allUnits, _allProfessionals, cloudLoaded, refreshFromCloud } = useData();
  const [tentando, setTentando] = useState(false);
  if (!CADASTRO_SEED_TRAVADO || !cloudLoaded) return null;
  if ((_allUnits?.length || 0) > 0 && (_allProfessionals?.length || 0) > 0) return null;
  const tentar = async () => {
    setTentando(true);
    try { await refreshFromCloud(); } catch { /* o aviso continua */ } finally { setTentando(false); }
  };
  return (
    <div className="px-4 pt-2 md:px-6">
      <AvisoSemDado texto={CADASTRO_SEM_COFRE} onTentar={tentar} tentando={tentando} />
    </div>
  );
}

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const isFullBleed = FULL_BLEED_ROUTES.some(r => location.pathname === r || location.pathname.startsWith(r + '/'));

  // [height:100dvh] corrige iOS PWA: 100vh inclui a faixa do home indicator
  // e "comia" a bottom nav; dvh é a altura realmente visível
  return (
    <div className="h-screen [height:100dvh] bg-canvas flex overflow-hidden">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <AvisoCadastroSemCofre />
        <main className={isFullBleed ? 'flex-1 overflow-hidden bg-white min-h-0' : 'flex-1 overflow-auto p-4 md:p-6 lg:p-8 bg-canvas'}>
          <Outlet />
        </main>
        {/* Bottom nav do PROFISSIONAL no celular (admin continua só com o drawer) */}
        <BottomNav onMenuClick={() => setSidebarOpen(true)} />
      </div>
      <PWAUpdateNotice />
      {CRM_VIGIA && <VigiaCrm />}
    </div>
  );
}
